import userActionTypes from "./user.types";

export const signOutStart = ({ token }) => ({
  type: userActionTypes.SIGN_OUT_START,
  payload: { token },
});

export const signOutSuccess = () => ({
  type: userActionTypes.SIGN_OUT_SUCCESS,
});

export const signOutFailure = ({ error, errorType }) => ({
  type: userActionTypes.SIGN_OUT_FAILURE,
  payload: { error, errorType },
});

export const logInSuccess = ({ token, userData }) => ({
  type: userActionTypes.LOG_IN_SUCCESS,
  payload: { token, userData },
});

export const logInFailure = ({ error, errorType }) => ({
  type: userActionTypes.LOG_IN_FAILURE,
  payload: { error, errorType },
});

export const logInStart = (emailAndPassword) => ({
  type: userActionTypes.LOG_IN_START,
  payload: emailAndPassword,
});

export const verifyEmailStart = ({ email, password, OTP }) => ({
  type: userActionTypes.VERIFY_EMAIL_START,
  payload: { email, password, OTP },
});

export const verifyEmailSuccess = ({ token, userData }) => ({
  type: userActionTypes.VERIFY_EMAIL_SUCCESS,
  payload: { token, userData },
});

export const verifyEmailFailure = ({ error, errorType }) => ({
  type: userActionTypes.VERIFY_EMAIL_FAILURE,
  payload: { error, errorType },
});

export const signUpStart = (signUpData) => ({
  type: userActionTypes.SIGN_UP_START,
  payload: signUpData,
});

export const signUpSuccess = ({ message, messageType }) => ({
  type: userActionTypes.SIGN_UP_SUCCESS,
  payload: { message, messageType },
});

export const signUpFailure = ({ error, errorType }) => ({
  type: userActionTypes.SIGN_UP_FAILURE,
  payload: { error, errorType },
});

export const forgotPasswordSuccess = ({ message, messageType }) => ({
  type: userActionTypes.FORGOT_PASSWORD_SUCCESS,
  payload: { message, messageType },
});

export const forgotPasswordFailure = ({ error, errorType }) => ({
  type: userActionTypes.FORGOT_PASSWORD_FAILURE,
  payload: { error, errorType },
});

export const forgotPasswordStart = (email) => ({
  type: userActionTypes.FORGOT_PASSWORD_START,
  payload: email,
});

export const resendValidationEmailStart = (email) => ({
  type: userActionTypes.RESEND_VALIDATION_EMAIL_START,
  payload: email,
});

export const resendValidationEmailSuccess = ({ message, messageType }) => ({
  type: userActionTypes.RESEND_VALIDATION_EMAIL_SUCCESS,
  payload: { message, messageType },
});

export const resendValidationEmailFailure = ({ error, errorType }) => ({
  type: userActionTypes.RESEND_VALIDATION_EMAIL_FAILURE,
  payload: { error, errorType },
});

export const resetPasswordStart = ({
  email,
  password,
  OTP,
  passwordConfirm,
}) => ({
  type: userActionTypes.RESET_PASSWORD_START,
  payload: { email, password, OTP, passwordConfirm },
});

export const resetPasswordSuccess = ({ token, userData }) => ({
  type: userActionTypes.RESET_PASSWORD_SUCCESS,
  payload: { token, userData },
});

export const resetPasswordFailure = ({ error, errorType }) => ({
  type: userActionTypes.RESET_PASSWORD_FAILURE,
  payload: { error, errorType },
});

export const uploadUserPhotosStart = ({ token, uploadType, imageUrls }) => ({
  type: userActionTypes.UPLOAD_USER_PHOTOS_START,
  payload: { token, uploadType, imageUrls },
});

export const uploadUserPhotosSuccess = (imageData) => ({
  type: userActionTypes.UPLOAD_USER_PHOTOS_SUCCESS,
  payload: imageData,
});

export const uploadUserPhotosFailure = ({ error, errorType }) => ({
  type: userActionTypes.UPLOAD_USER_PHOTOS_FAILURE,
  payload: { error, errorType },
});

export const updateProfileDataStart = ({ token, data }) => ({
  type: userActionTypes.UPDATE_PROFILE_DATA_START,
  payload: { token, data },
});

export const updateProfileDataSuccess = ({ userData }) => ({
  type: userActionTypes.UPDATE_PROFILE_DATA_SUCCESS,
  payload: userData,
});

export const updateProfileDataFailure = ({ error, errorType }) => ({
  type: userActionTypes.UPDATE_PROFILE_DATA_FAILURE,
  payload: { error, errorType },
});

export const updateProfileDataValidate = ({ message, messageType }) => ({
  type: userActionTypes.UPDATE_PROFILE_DATA_VALIDATE,
  payload: { message, messageType },
});

export const fetchUserCoinsStart = (token) => ({
  type: userActionTypes.FETCH_USER_COINS_START,
  payload: token,
});

export const fetchUserCoinsSuccess = (coins) => ({
  type: userActionTypes.FETCH_USER_COINS_SUCCESS,
  payload: coins,
});

export const fetchUserCoinsFailure = ({ error, errorType }) => ({
  type: userActionTypes.FETCH_USER_COINS_FAILURE,
  payload: { error, errorType },
});

export const checkUserSession = () => ({
  type: userActionTypes.CHECK_USER_SESSION,
});

export const updateUserLocation = ({ country, preferredCurrency }) => ({
  type: userActionTypes.UPDATE_USER_LOCATION,
  payload: { country, preferredCurrency },
});

export const syncUserDataStart = (token) => ({
  type: userActionTypes.SYNC_USER_DATA_START,
  payload: token,
});

export const syncUserDataSuccess = (userData) => ({
  type: userActionTypes.SYNC_USER_DATA_SUCCESS,
  payload: userData,
});

export const syncUserDataFailure = (error) => ({
  type: userActionTypes.SYNC_USER_DATA_FAILURE,
  payload: error,
});
